import React from 'react';
import Dialog from './Dialog';
import Button from './Button';
import { useT } from '../../i18n';

/**
 * ConfirmDialog — a focused confirm/cancel modal built on Dialog. Use for
 * destructive or irreversible actions instead of window.confirm().
 *
 * Props:
 *   open, onCancel, onConfirm
 *   title, description / children
 *   confirmLabel='Confirm', cancelLabel='Cancel'
 *   tone: 'primary' | 'danger'        — confirm button style (default 'primary')
 *   loading: boolean                  — confirm in progress
 */
const ConfirmDialog = ({
  open,
  onCancel,
  onConfirm,
  title,
  description,
  confirmLabel,
  cancelLabel,
  tone = 'primary',
  loading = false,
  children,
}) => {
  const t = useT();
  return (
    <Dialog
      open={open}
      onClose={loading ? () => {} : onCancel}
      title={title}
      description={description}
      size="sm"
      closeOnScrim={!loading}
      footer={
        <>
          <Button variant="ghost" onClick={onCancel} disabled={loading}>{cancelLabel ?? t('Cancel')}</Button>
          <Button variant={tone === 'danger' ? 'destructive' : 'primary'} onClick={onConfirm} loading={loading}>
            {confirmLabel ?? t('Confirm')}
          </Button>
        </>
      }
    >
      {children}
    </Dialog>
  );
};

export default ConfirmDialog;
